export default __webpack_public_path__ + "media/zurb/img/case-study-paysa/paysa-sketches-5839f25889a6519f178cd1c97c46199f.png";